import React from 'react';
import { FormCheckBox, FormCheckBoxLabel } from '@styled/Form';
import { Checked, MixChecked, UnChecked } from '@shared/icons/icons';
import { appColors } from '@styled/useTheme';
function CheckBox(_a) {
    var checked = _a.checked, action = _a.action, label = _a.label, css = _a.css, _b = _a.disabled, disabled = _b === void 0 ? false : _b;
    return (React.createElement(FormCheckBox, { onClick: disabled ? undefined : action, style: css, "$disabled": disabled },
        checked ? React.createElement(Checked, { color: disabled ? appColors.neutral.w700 : appColors.primary.w500 }) : React.createElement(UnChecked, null),
        label !== undefined && React.createElement(FormCheckBoxLabel, null, label)));
}
function ThreeStateCheckBox(_a) {
    var value = _a.value, action = _a.action, label = _a.label, css = _a.css, labelStyle = _a.labelStyle, _b = _a.disabled, disabled = _b === void 0 ? false : _b;
    return (React.createElement(FormCheckBox, { onClick: action, style: css },
        value === null ? (React.createElement(MixChecked, null)) : value ? (React.createElement(Checked, { color: disabled ? appColors.neutral.w700 : appColors.primary.w500 })) : (React.createElement(UnChecked, null)),
        label !== undefined && React.createElement(FormCheckBoxLabel, { style: labelStyle }, label)));
}
export { CheckBox, ThreeStateCheckBox };
